

import "./bVersionCheck/bVersionCheck.sass";

import apiConstant from './api.constant';
import { ItCacheService } from './ItCache.service';
import { TLVCacheService } from './TLVCache.service';
import { bVersionCheckDirective } from './bVersionCheck/bVersionCheck.directive';
import { VersionCheckService } from './VersionCheck.service';
import { ConnectionQualityService } from './ConnectionQuality.service';

export default angular.module('frontend.api', [])
  .constant('API', apiConstant)
  .directive('bVersionCheck', bVersionCheckDirective)
  .service('VersionCheck', VersionCheckService)
  .service('ItCache', ItCacheService)
  .service('TLVCache', TLVCacheService)
  .service('ConnectionQuality', ConnectionQualityService);
